import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
type SiteLinkProps = {
  to: string;
  className?: string;
  children: ReactNode;
  onClick?: () => void;
  'aria-label'?: string;
};
function isExternal(to: string) {
  return /^(https?:|tel:|sms:|mailto:|#)/.test(to);
}
export function SiteLink({
  to,
  className,
  children,
  ...rest
}: SiteLinkProps) {
  if (isExternal(to)) {
    const isWeb = /^https?:/.test(to);
    return <a href={to} className={className} target={isWeb ? '_blank' : undefined} rel={isWeb ? 'noopener noreferrer' : undefined} {...rest} data-id="element-471" data-mp="3iaqm2902hze">
        {children}
      </a>;
  }
  return <Link to={to} className={className} {...rest} data-id="element-472" data-mp="3qntdqru70po4">
      {children}
    </Link>;
}